import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { PageHeaderComponent } from 'app/core/components/page-header/page-header.component';
import { AppSettings } from '@services/settings/app-settings.service';
import { DocProcessListComponent } from '../../components/process-list/process-list.component';

@Component({
  selector: 'app-process-document-management',
  standalone: true,
  imports: [CommonModule, RouterLink, PageHeaderComponent, DocProcessListComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './process-document-management.component.html'
})
export class ProcessDocumentManagementComponent {
  readonly appSettings = inject(AppSettings);
}
